import React from 'react';
import { Icons } from '@ohif/ui-next';

interface SearchBarProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  onSearch?: (value: string) => void;
  variant?: 'dark' | 'light';
}

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = 'Search',
  value,
  onChange,
  onSearch,
  variant = 'dark',
}) => {
  const isLight = variant === 'light';
  const backgroundColor = isLight ? '#f8fafc' : '#1e293b';
  const borderColor = isLight ? '#e2e8f0' : '#334155';
  const textColor = isLight ? '#64748b' : '#ffffff';
  const iconColor = isLight ? '#64748b' : '#94a3b8';
  const focusBorderColor = 'var(--accent-primary)';
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && onSearch) {
      onSearch(value);
    }
  };

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        maxWidth: '400px',
      }}
    >
      <div
        style={{
          position: 'absolute',
          left: '12px',
          top: '50%',
          transform: 'translateY(-50%)',
          display: 'flex',
          alignItems: 'center',
          pointerEvents: 'none',
        }}
      >
        <Icons.Search
          width="16"
          height="16"
          style={{ color: iconColor }}
        />
      </div>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={e => onChange(e.target.value)}
        onKeyPress={handleKeyPress}
        style={{
          width: '100%',
          height: isLight ? '36px' : '40px',
          paddingLeft: '40px',
          paddingRight: '12px',
          backgroundColor: backgroundColor,
          border: `1px solid ${borderColor}`,
          borderRadius: '6px',
          color: textColor,
          WebkitTextFillColor: textColor, // Ensure text color is maintained
          fontSize: '14px',
          outline: 'none',
          boxShadow: isLight ? 'inset 0px 2px 4px 0px rgba(0,0,0,0.06)' : 'none',
        }}
        onFocus={e => {
          e.currentTarget.style.borderColor = focusBorderColor;
          // Maintain text color on focus to prevent browser from applying black text
          e.currentTarget.style.color = textColor;
          e.currentTarget.style.WebkitTextFillColor = textColor;
        }}
        onBlur={e => {
          e.currentTarget.style.borderColor = borderColor;
        }}
      />
    </div>
  );
};

export default SearchBar;
